import {Button, Modal, Spinner} from "react-bootstrap";
import React, {useState} from "react";
import axios from "axios";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import Input from "../../../../common/Input";

const RejectDeliveryNoteModal = ({show, setShow, qrUrls, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");

    const onAccept = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/reject-delivery-note`, {
            qrUrls,
            rejectionReason,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.errors) {
                    for (const err of res.data.errors) {
                        toast.error(err);
                    }
                }
                const successCount = qrUrls.length - res.data.errors.length;
                if (successCount > 0) toast.success(`Επιτυχής απόρριψη ${successCount} Δ.Α.`);
                setShow(false);
                if (successCallback) successCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
            <Modal.Header closeButton>
                <Modal.Title>Απόρριψη</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Είσαστε σίγουροι ότι θέλετε να απορρίψετε {qrUrls.length > 1 ? "τις διακινήσεις" : "την διακίνηση"};
                <hr className={"mt-2 mb-2"} />
                <Input
                    name={"rejectionReason"}
                    label={"Λόγος Απόρριψης"}
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onAccept()} disabled={loading}>
                    Απόρριψη {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RejectDeliveryNoteModal;
